/* istanbul ignore file */
// collect here the functions related to directly applying on html elements

export function setCursorByID(id: string, cursorStyle: string) {
  let elem;
  if (document.getElementById && (elem = document.getElementById(id))) {
    if (elem.style) elem.style.cursor = cursorStyle;
  }
}
